import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import uploadIcon from '../action-menu/icon--file-upload.svg';

import styles from './user-center.css';

const GENDER_OPTIONS = [
    {
        value: '1',
        label: '男生'
    },
    {
        value: '2',
        label: '女生'
    },
    {
        value: '0',
        label: '保密'
    }
];

const getStatusClassName = statusType => classNames(styles.formStatus, {
    [styles.statusSuccess]: statusType === 'success',
    [styles.statusError]: statusType === 'error'
});

const ProfilePage = props => {
    const form = props.form;
    const avatarSrc = props.getAvatarSrc(form.avatar);

    return (
        <form
            className={styles.profileForm}
            onSubmit={props.onSubmit}
        >
            <div className={styles.formTop}>
                <div className={styles.avatarEditor}>
                    <button
                        className={styles.avatarButton}
                        type="button"
                        onClick={props.onAvatarPick}
                    >
                        {avatarSrc ? (
                            <img
                                className={styles.avatarImage}
                                src={avatarSrc}
                            />
                        ) : (
                            <span className={styles.avatarInitial}>
                                {(form.nickname || '跃').charAt(0)}
                            </span>
                        )}
                        <span className={styles.avatarOverlay}>
                            <img
                                className={styles.uploadIcon}
                                src={uploadIcon}
                            />
                            {'更换头像'}
                        </span>
                    </button>
                    <input
                        accept="image/*"
                        aria-label="选择头像"
                        className={styles.avatarFileInput}
                        ref={props.setAvatarInput}
                        type="file"
                        onChange={props.onAvatarChange}
                    />
                </div>
                <div className={styles.profileSummary}>
                    <div className={styles.summaryTitle}>
                        {form.nickname || '设置你的昵称'}
                    </div>
                    <div className={styles.summaryText}>
                        {'完善资料后，老师和同学能更容易认识你的作品。'}
                    </div>
                </div>
            </div>

            <div className={styles.formGrid}>
                <label className={styles.field}>
                    <span className={styles.fieldLabel}>{'用户昵称'}</span>
                    <input
                        className={styles.textInput}
                        data-field="nickname"
                        maxLength="20"
                        placeholder="例如：小小创客"
                        value={form.nickname}
                        onChange={props.onChange}
                    />
                </label>
                <label className={styles.field}>
                    <span className={styles.fieldLabel}>{'姓名'}</span>
                    <input
                        className={styles.textInput}
                        data-field="name"
                        maxLength="20"
                        placeholder="填写真实姓名"
                        value={form.name}
                        onChange={props.onChange}
                    />
                </label>
                <label className={styles.field}>
                    <span className={styles.fieldLabel}>{'年龄'}</span>
                    <input
                        className={styles.textInput}
                        data-field="age"
                        inputMode="numeric"
                        maxLength="3"
                        placeholder="例如：10"
                        value={form.age}
                        onChange={props.onChange}
                    />
                </label>
                <div className={styles.field}>
                    <span className={styles.fieldLabel}>{'性别'}</span>
                    <div className={styles.genderOptions}>
                        {GENDER_OPTIONS.map(option => (
                            <label
                                className={classNames(styles.genderOption, {
                                    [styles.genderOptionActive]: form.sex === option.value
                                })}
                                key={option.value}
                            >
                                <input
                                    checked={form.sex === option.value}
                                    name="user-center-sex"
                                    type="radio"
                                    value={option.value}
                                    onChange={props.onGenderChange}
                                />
                                <span>{option.label}</span>
                            </label>
                        ))}
                    </div>
                </div>
                <label className={classNames(styles.field, styles.descriptionField)}>
                    <span className={styles.fieldLabel}>{'个人描述'}</span>
                    <textarea
                        className={styles.textarea}
                        data-field="description"
                        maxLength="120"
                        placeholder="写下你喜欢的创作主题、角色或故事"
                        value={form.description}
                        onChange={props.onChange}
                    />
                </label>
            </div>

            <div className={styles.formFooter}>
                <div className={getStatusClassName(props.saveStatusType)}>
                    {props.saveStatus}
                </div>
                <div className={styles.formActions}>
                    <button
                        className={styles.secondaryButton}
                        disabled={props.saving}
                        type="button"
                        onClick={props.onReset}
                    >
                        {'还原'}
                    </button>
                    <button
                        className={styles.primaryButton}
                        disabled={props.saving}
                        type="submit"
                    >
                        {props.saving ? '保存中' : '保存资料'}
                    </button>
                </div>
            </div>
        </form>
    );
};

ProfilePage.propTypes = {
    form: PropTypes.shape({
        age: PropTypes.string,
        avatar: PropTypes.string,
        description: PropTypes.string,
        name: PropTypes.string,
        nickname: PropTypes.string,
        sex: PropTypes.string
    }).isRequired,
    getAvatarSrc: PropTypes.func.isRequired,
    onAvatarChange: PropTypes.func.isRequired,
    onAvatarPick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onGenderChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    saveStatus: PropTypes.string,
    saveStatusType: PropTypes.string,
    saving: PropTypes.bool,
    setAvatarInput: PropTypes.func.isRequired
};

ProfilePage.defaultProps = {
    saveStatus: '',
    saveStatusType: 'info',
    saving: false
};

export default ProfilePage;
